export default
{
    data() {
        return {
            mail: '',
            message: null,
            error: 0
        }
    },

    methods:
    {
        close()
        {
            this.eventHub.$emit('subscribe:close')
        },

        onSended(content)
        {
            if (content.error > 0)
            {
                this.error = 1
                this.message = content.detail
            }
            else
            {
                this.error = 0
                this.message = content.detail && content.detail != '' ? content.detail : 'Email saved'
            }
        },

        send()
        {
            const init = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: 'email=' + encodeURIComponent(this.mail)
            }

            window.fetch('/api/subscribe.php', init)
                .then(response => response.json())
                .then(this.onSended)
                .catch(error => this.onSended({ error: 1, detail: error.message }))
        }
    }
}